import React, { useEffect } from 'react'

import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { useDoubleDeckerNav } from 'hooks/useDoubleDeckerNav'
import { useBasket } from 'routes/Menu/domains/basket'
import { useMenu } from 'routes/Menu/domains/menu'
import { getIsPolicyAccepted } from 'selectors/cookies'

import { useCollections } from '../../domains/collections'
import { CollectionsNav } from './CollectionsNav'
import { useTracking } from './useTracking'

import css from './CollectionsNav.css'

const CollectionsNavWrapper = (ownProps) => {
  const { currentCollectionId, collections, changeCollectionById } = useCollections()
  const isPolicyAccepted = useSelector(getIsPolicyAccepted)

  const { menuId } = useBasket()
  const doubleDeckerExperimentEnabled = useDoubleDeckerNav()
  const { categoryPersonalisationBucket } = useMenu()

  const track = useTracking({ collections, menuId, categoryPersonalisationBucket })
  useEffect(() => track(), [track])

  return (
    <div
      className={classnames({
        [css.doubleDeckerCollectionsNavWrapper]: doubleDeckerExperimentEnabled,
      })}
    >
      <CollectionsNav
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...ownProps}
        changeCollectionById={changeCollectionById}
        menuCollections={collections}
        menuCurrentCollectionId={currentCollectionId}
        isPolicyAccepted={isPolicyAccepted}
        doubleDeckerExperimentEnabled={doubleDeckerExperimentEnabled}
      />
    </div>
  )
}

export { CollectionsNavWrapper }
